import React from "react";
import { style } from "typestyle";

type WorkflowStepAlertProps = {
  header: string;
  message: string;
};

export default function WorkflowStepAlert(props: WorkflowStepAlertProps) {
  return (
    <div
      className={style({
        width: "100%",
        padding: "14px 16px",
        backgroundColor: "#FBEA9F",
        display: "flex",
        alignItems: "center",
      })}
    >
      <AlertIcon />
      <div
        className={style({
          paddingLeft: "16px",
        })}
      >
        <div
          className={style({
            color: "#000",
            fontSize: "16px",
            fontWeight: 500,
            lineHeight: "24px",
          })}
        >
          {props.header}
        </div>
        <div
          className={style({
            color: "#000",
            fontSize: "14px",
            lineHeight: "20px",
          })}
        >
          {props.message}
        </div>
      </div>
    </div>
  );
}

const AlertIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M39.8005 40H8.19954C4.96811 40 2.95371 36.4651 4.56943 33.6499L20.3699 6.11142C21.9856 3.29619 26.0144 3.29619 27.6301 6.11142L43.4306 33.6499C45.0463 36.4651 43.0319 40 39.8005 40ZM21.6916 24.7364C21.6916 25.9815 22.7303 27.0001 23.9998 27.0001C25.2692 27.0001 26.3079 25.9815 26.3079 24.7364V18.2637C26.3079 17.0187 25.2692 16 23.9998 16C22.7303 16 21.6916 17.0187 21.6916 18.2637V24.7364ZM24.044 33.8756C25.2942 33.8756 26.3077 32.8621 26.3077 31.6118C26.3077 30.3616 25.2942 29.3481 24.044 29.3481H23.9551C22.7049 29.3481 21.6914 30.3616 21.6914 31.6118C21.6914 32.8621 22.7049 33.8756 23.9551 33.8756H24.044Z"
      fill="#F2CB00"
    />
  </svg>
);
